import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../endpoints";
import * as gatewayAndPriceListActions from "../actions/gateway_and_price_list_actions";
import * as gatewayAndPriceListTypes from "../types/gateway_and_price_list_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfGatewayAndPrice(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_GATEWAY_AND_PRICE_SMS, action.payload);
    if (res.status === 200) {
      yield put(gatewayAndPriceListActions.getListOfGatewayAndPriceSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayAndPriceListActions.getListOfGatewayAndPriceError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayAndPriceListActions.getListOfGatewayAndPriceError(e));
  }
}

function* editGatewayAndPrice(action) {
  try {
    const res = yield call(api.patch, `${endpoints.SUPER_ADMIN_GATEWAY_AND_PRICE_SMS}/${action.payload.id}`, action.payload.data);
    if (res.status === 200) {
      yield put(gatewayAndPriceListActions.editGatewayAndPriceSuccess(res.data));
      yield put(gatewayAndPriceListActions.getListOfGatewayAndPriceRequest(action.payload.loadingData));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(gatewayAndPriceListActions.editGatewayAndPriceError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(gatewayAndPriceListActions.editGatewayAndPriceError(e));
  }
}

export default function* gatewayAndPriceListSaga() {
  yield takeLatest(gatewayAndPriceListTypes.getListOfGatewayAndPrice.GET_LIST_OF_GATEWAY_AND_PRICE_REQUEST, getListOfGatewayAndPrice);
  yield takeLatest(gatewayAndPriceListTypes.editGatewayAndPrice.EDIT_GATEWAY_AND_PRICE_REQUEST, editGatewayAndPrice);
}
